import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel from "@/__main__/data-model.mjs";

export const ConsoleMatch = {
  gameMode: String,
  inputType: String,
  kills: Number,
  outlived: Number,
  score: Number,
  id: String,
  insertedAt: Date,
  matchCount: Number,
} satisfies ModelDefinition;

const ConsoleMatchesValidator = createModel({
  data: {
    matchSummaries: [ConsoleMatch],
  },
}).transform([ConsoleMatch], (response) => response.data.matchSummaries);

export type ConsoleMatch = FromModel<typeof ConsoleMatch>;

export default ConsoleMatchesValidator;
